import React from 'react';

// Imported only to keep their CSS ahead of `.unbutton` in the production app.css;
// later, `.sg-button` would win ties and restyle every legacy link and text button.
import 'sg/Tables/MandarkTable/MandarkTable.react';
import 'client/styleguide/Button/Button.react';
import UpgradeCallToActionModal from './UpgradeCallToActionModal/UpgradeCallToActionModal';

interface Props {
  pathname: string;
}

export default function ModalCollection({pathname}: Props) {
  return (
    <>
      <UpgradeCallToActionModal pathname={pathname} />
    </>
  );
}
